import en from "~~/i18n/locales/en.js";
import sv from "~~/i18n/locales/sv.js";

export const useTranslationOverrides = () => {
  const { $i18n } = useNuxtApp();

  const loadTranslationOverrides = (translations: string | Record<string, unknown> | null) => {
    // 1. reset current translations
    $i18n.setLocaleMessage("en", en);
    $i18n.setLocaleMessage("sv", sv);

    // 2. load customer translations
    if (!translations) return;
    let overrides: Record<string, unknown> = {};

    // 3. Try to parse a JSON string
    try {
      overrides = JSON.parse(translations as string);
    } catch (_e) {
      overrides = translations as Record<string, unknown>;
    }

    if (!overrides || Object.keys(overrides).length === 0) return;

    // 4. Merge into each locale - customer overrides win
    for (const locale of $i18n.availableLocales) {
      if (overrides[locale]) {
        $i18n.mergeLocaleMessage(locale, overrides[locale]);
      }
    }
  };

  return { loadTranslationOverrides };
};